type ScaleType = 'linear' | 'log';

function shouldUseLogScale(values: number[]): boolean {
  const positives = values.filter((v) => v > 0).sort((a, b) => a - b);
  if (positives.length < 3) return false;

  const median = positives[Math.floor(positives.length / 2)];
  const max = positives[positives.length - 1];
  if (max / median > 5) return true;

  const q1 = positives[Math.floor(positives.length * 0.25)];
  const q3 = positives[Math.floor(positives.length * 0.75)];
  const iqr = q3 - q1;
  const upperFence = q3 + 1.5 * iqr;
  const outlierCount = positives.filter((v) => v > upperFence).length;
  if (outlierCount / positives.length > 0.1) return true;

  return false;
}

function normalizeValue(value: number, max: number, scale: ScaleType): number {
  if (max === 0) return 0;
  if (scale === 'log') {
    return Math.log(1 + value) / Math.log(1 + max);
  }
  return value / max;
}

export { normalizeValue, shouldUseLogScale };
export type { ScaleType };
